import { User, UserTableVisualization } from '../../data/model/user';
import { Permission } from '../../data/model/permission';
import { UserPortalGroup } from '../../data/model/user-portal-group';
;

export interface State {
  user: User | null;
  group: UserPortalGroup[] | null;
  loadingCount: number;
  navbar: boolean;
  permissions: Permission[] | undefined;
  modules: UserTableVisualization[];
}

export const initialState: State = {
  user: null,
  group: null,
  loadingCount: 0,
  navbar: false,
  permissions: [],
  modules: [],
};
